import React from 'react';
import View from '../cruds/View';
import Edit from '../cruds/Edit';
import Iterate from '../components/container/Iterate';
import {OutputAttachmentRow, OutputAttachmentRowDisabled} from '../components/output/OutputAttachments';
import {SDS_VERSION_EDITABLE, ShowBasedOnConfig} from '../components/container/ShowBasedOnConfig';
import OutputText, {SimpleOutputText} from '../components/output/OutputText';
import ButtonLink from '../components/output/ButtonLink';
import {OutputLink} from '../components/output/OutputLink';
import {notEmpty} from '../cruds/validators';
import {Horizontal, HorizontalInput, Vertical, VerticalInput} from '../components/container/LayoutRow';
import {Route, Switch} from 'react-router-dom';
import SafetyDataSheetsArchive from './SafetyDataSheetsArchive';
import InputText from '../components/input/InputText';
import InputUpload from '../components/input/InputUpload';
import './SafetyDataSheets.css';
import {ShowBasedOnCondition} from "../components/container/ShowBasedOnCondition";


const FATHER_ENTITY_ROUTE = 'substances';
const FATHER_ENTITY_NAME = 'substances';
const ENTITY_NAME = 'safetyDataSheets';
const ENTITY_ROUTE = 'safetyDataSheet';

const CrudEdit = (props) => {
    const basePath = buildFullEntity(props.parentId);
    const baseRoute = FATHER_ENTITY_ROUTE;

    const validators = [
        notEmpty('attachments', 'substances.err.attachments'),
    ];

    return (
        <Edit {...props}
              crudClassName="safetyDataSheets-edit"
              overrideTitle="substances.addSds"
              entityName={basePath}
              entityRoute={baseRoute}
              entityId="new"
              validators={validators}
        >
            <HorizontalInput style={{alignItems: 'flex-start'}}>
                <VerticalInput>
                    <SimpleOutputText name="substanceCode" label="substances.idCode"/>
                    <InputText name="sds" label="substances.sds"/>
                    <ShowBasedOnConfig name="safetyDataSheetVersion" configKey={SDS_VERSION_EDITABLE}>
                        <InputText label="substances.safetyDataSheetVersion"/>
                    </ShowBasedOnConfig>
                </VerticalInput>
            </HorizontalInput>
            <InputUpload name="attachments"
                         label="substances.attachments"
                         to="attachments"
                         required
            />
        </Edit>
    );
};

const ViewButtons = ({entityRoute, entityId}, resource) => (
    <div>
        {/*     <DownloadButton from={'departmentActivitySubstances/evaluations/' + (resource ? resource.departmentActivitySubstanceId : -1)}
        type="application/pdf"
        extension="pdf"
        iconType="button"
        style={{ marginLeft: '10px' }}
    />
    <ButtonLink
        to={'/' + entityRoute}
        label="evaluations.viewArchive"
        style={{ marginLeft: '10px' }}
    /> */}
        <ButtonLink
            to={'/' + FATHER_ENTITY_ROUTE}
            label="general.close"
            style={{marginLeft: '10px'}}
        />
    </div>
);

const buildFullEntity = (parentId) => {
    return [FATHER_ENTITY_NAME, parentId, ENTITY_NAME].join('/');
};

const buildFullRoute = (parentId) => {
    return [FATHER_ENTITY_ROUTE, parentId, ENTITY_ROUTE].join('/');
};

const CrudView = props => (
    <View crudClassName="substances-view" title="substances.sdsLong"
          entityName={buildFullEntity(props.parentId)}
          entityRoute={buildFullRoute(props.parentId)}
          entityId={props.match.params.number}
          buttons={ViewButtons}>

        <Horizontal style={{alignItems: 'flex-start'}}>
            <Vertical>
                <OutputText name="substanceCode" label="substances.idCode"/>
                <ShowBasedOnCondition evaluateOnField="downloadable" condition={v => v === true}>
                    <OutputLink name="sds" label="substances.sds"/>
                </ShowBasedOnCondition>
                <ShowBasedOnCondition evaluateOnField="downloadable" condition={v => v === false}>
                    <OutputText name="sds" label="substances.sds" style={{color: '#c7c7c7'}}/>
                </ShowBasedOnCondition>
                <ShowBasedOnCondition evaluateOnField="downloadable" condition={v => v === true}>
                    <Iterate on="attachments" label="substances.attachments">
                        <OutputAttachmentRow/>
                    </Iterate>
                </ShowBasedOnCondition>
                <ShowBasedOnCondition evaluateOnField="downloadable" condition={v => v === false}>
                    <Iterate on="attachments" label="substances.attachments">
                        <OutputAttachmentRowDisabled/>
                    </Iterate>
                </ShowBasedOnCondition>
            </Vertical>
        </Horizontal>
    </View>
);

const CrudList = props => (
    <SafetyDataSheetsArchive substanceId={props.parentId}/>
);

const SafetyDataSheet = props => {
    const basePath = props.match.url;
    const parentId = props.match.params.number;

    return (
        <Switch>
            <Route exact path={basePath} render={props => <CrudList parentId={parentId} {...props} />}/>
            <Route exact path={basePath + '/:number/view'}
                   render={props => <CrudView parentId={parentId} {...props} />}/>
            <Route exact path={basePath + '/new'} render={props => <CrudEdit parentId={parentId} {...props} />}/>
        </Switch>
    );
};

export default SafetyDataSheet;



// WEBPACK FOOTER //
// ./src/main/pages/SafetyDataSheets.js